export default {
  getOnlineLectureHostsOfAnInstitute: '/onlineLectureHost/getOnlineLectureHostsOfAnInstitute',
  getAllCurrentlyOngoingLectures: '/onlineLecture/getAllCurrentlyOngoingLectures',
  updateOnlineLecture: '/onlineLecture/updateOnlineLecture',
  getLinkOfOnlineLecture: '/onlineLecture/getOnlineLecture',
  getRedirectionUrl: '/onlineLectureStudent/getRedirectionUrl',
  getRecordingOfAnOnlineLecture: '/onlineLectureStudent/getRecordingOfAnOnlineLecture'
}
